import { EPaymentFrequency } from '@if/core/types'
import { useIfUser } from '@if/mui'
import { CalendarSimulation } from '@src/types/loan/loan-simulation'
import { useMemo } from 'react'
import { getAllLoanCalendarValidIntervalForNewFirstPaymentDateForOperation } from './LoanCalendarFrequency-selectors'

export const useShouldDisableDateForNewFirstPayment = (
  simulation: CalendarSimulation,
  frequency: EPaymentFrequency,
) => {
  const user = useIfUser()
  const canBypassAcpLock = user.rights.canEditLockedPpaPayments
  return useMemo(() => {
    const intervals = getAllLoanCalendarValidIntervalForNewFirstPaymentDateForOperation(
      simulation,
      frequency,
      canBypassAcpLock,
    )
    return (date: Date) => {
      return !intervals.some(([min, max]) => date >= min && date <= max)
    }
  }, [simulation, frequency, canBypassAcpLock])
}
